import { filter, mergeMap } from 'rxjs/operators';

import { RootEpic } from '../../../store/epics';
import { ErrorType } from '../../../store/reducers/common';
import { nextStep } from '../../application/reducers/next-step';
import { loadPersona, loadPersonaFail, loadPersonaSuccess } from '../reducers/persona';

const loadPersonaEpic: RootEpic = (action$, state$, { api }) => {
  return action$.pipe(
    filter(loadPersona.match),
    mergeMap(async () => {
      const { persona } = state$.value.config.config!;
      return api.persona
        .runPersona(persona)
        .then((inquiryId) => [
          loadPersonaSuccess(inquiryId),
          nextStep({
            action: 'persona',
            gotoNextPage: true,
          }),
        ])
        .catch((err: ErrorType) => [loadPersonaFail(err)]);
    }),
    mergeMap((action) => action),
  );
};

export { loadPersonaEpic };
